import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { RhheaderTable } from "./RhheaderTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./rhheaderSlice";

export const RHHeaderPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [rayonCode, setRayonCode] = useState("");
  const [rayonType, setRayonType] = useState("");
  const [plant, setPlant] = useState("");
  const [validFrom, setValidFrom] = useState("");
  const [validTo, setValidTo] = useState("");
  const [FSS, setFSS] = useState("");
  const [SLM, setSLM] = useState("");


  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      rayonCode: rayonCode,
      rayonType: rayonType,
      plant: plant,
      validFrom: validFrom,
      validTo: validTo,
      FSS:FSS,
      SLM:SLM,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      rayonCode: rayonCode,
      rayonType: rayonType,
      plant: plant,
      validFrom: validFrom,
      validTo: validTo,
      FSS:FSS,
      SLM:SLM,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="RH Header"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Rayon Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Rayon Code"
                    onChange={(e) => {
                      setRayonCode(e.target.value);
                    }}
                    value={rayonCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Rayon Type</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Rayon Type"
                    onChange={(e) => {
                      setRayonType(e.target.value);
                    }}
                    value={rayonType}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plant</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Plant"
                    onChange={(e) => {
                      setPlant(e.target.value);
                    }}
                    value={plant}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>FSS</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="FSS"
                    onChange={(e) => {
                      setFSS(e.target.value);
                    }}
                    value={FSS}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid From</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid From"
                    onChange={(e) => {
                      setValidFrom(e.target.value);
                    }}
                    value={validFrom}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid To</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid To"
                    onChange={(e) => {
                      setValidTo(e.target.value);
                    }}
                    value={validTo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>SLM</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="SLM"
                    onChange={(e) => {
                      setSLM(e.target.value);
                    }}
                    value={SLM}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <RhheaderTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
